import styled, { css } from 'styled-components';
import { SPACING } from '~/common/constants/spacing';

interface ICollapseContainer {
  $isOpen: boolean;
  /* Transiente ($): sem o prefixo, styled-components v6 repassa a prop para o
     DOM e o React reclama de atributo desconhecido no console. */
  $contentHeight: number;
  $hasBoxShadow?: boolean;
  $hasMarginBottom?: boolean;
}

export const CollapseContainer = styled.div<ICollapseContainer>`
  max-height: ${({ $isOpen, $contentHeight }) =>
    $isOpen ? `${$contentHeight}px` : '0px'};
  ${({ $isOpen, $hasMarginBottom }) =>
    $hasMarginBottom &&
    css`
      margin-bottom: ${$isOpen ? '0px' : `-${SPACING._20}`};
    `};
  overflow: hidden;
  transition: max-height 300ms ease;

  ${({ $hasBoxShadow }) =>
    $hasBoxShadow &&
    css`
      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    `};
`;
